import { render, staticRenderFns } from "./pannier.vue?vue&type=template&id=319fd1e2&scoped=true"
import script from "./pannier.vue?vue&type=script&lang=js"
export * from "./pannier.vue?vue&type=script&lang=js"
import style0 from "./pannier.vue?vue&type=style&index=0&id=319fd1e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319fd1e2",
  null
  
)

export default component.exports